// Never round a sub-target crash UP into an apparent matching/winning result.
// E8 is the exact recorded result; truncate only the two-decimal presentation.
export const limboDisplayValue = (crashE8) => Math.floor(crashE8 / 1000000) / 100;
export const formatLimboResult = (crashE8) => limboDisplayValue(crashE8).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });